import React, {useEffect, useState} from 'react'
// import PropTypes from 'prop-types'
import axios from 'axios'

// STYLE //
import './stylesMain.scss'

// COMPONENTS //
import MovieCard from '../MovieCard/MovieCard'
import Custombutton from '../Custombutton/Custombutton'
import Loader from '../Loader/Loader'
import CustomMenu from '../CustomMenu/CustomMenu'
import StreamCard from '../StreamCard/StreamCard'
import BuyCard from '../BuyCard/BuyCard'


// API URL //
// import API_URL from '../../utils/API_BaseUrl'

// HOOKS //
// import useGenre from '../../hooks/useGenre'


// import Button from '@mui/material/Button';
// import { blue, red } from '@mui/material/colors'




function Main(props) {

  const [num, setNum] = useState(0);
  const [movies, setMovies]= useState([])
  const [genres, setGenres]= useState('')
  const [genresName, setGenresName]= useState([])
  const [genresId, setGenresId]= useState(null)
  const [open, setOpen] = useState(false);
  const [movieId, setMovieId] =useState([])
  const [isLoading, setLoading] = useState(false)
  const [moviesStreamData, setMoviesStreamData] = useState([])
  const [buyMoviesData, setBuyMoviesData] = useState([])

  
  


 
 // FETCH MOVIES //

  // const fetchMovies = async () => {
  //   const {data}  = await axios.get(` https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}&language=fr-FR&sort_by=popularity.desc&incinclude_video=true&page=${num}&with_genres=${genresId}&with_watch_monetization_types=flatrate` 
  //   )
  //   setMovies(data.results)
  //   console.log(movies)  
  //   console.log(movieId);
  // }


  useEffect(() => {
    const fetchMovies = async () => {
      setLoading(true);
      try {
          const {data}  = await axios.get(` https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}&language=fr-FR&sort_by=popularity.desc&include_adult=false&incinclude_video=true&page=${num}&with_genres=${genresId}&with_watch_providers=true&with_watch_monetization_types=rent` 
    )
    setMovies(data.results)
    // console.log(movies)  
      } catch (error) {
        console.log(error);
      }
      setLoading(false)
    }
    fetchMovies()

  }, [num])
  

  // const shuffle =  movies.sort(() => Math.random() - 0.5)
 

  // FETCH STREAM 
  const fetchStream = async () => {
    const {data} = await axios.get(`https://api.themoviedb.org/3/movie/58/watch/providers?api_key=${process.env.REACT_APP_API_KEY}&language=fr-FR`)

    setMoviesStreamData(data.results.FR.flatrate)   
    setBuyMoviesData(data.results.FR.buy)
    console.log(moviesStreamData);
    console.log(buyMoviesData);
 
  }

  useEffect(() => {
    fetchStream()
  }, [])
  
  


  // const VIDEO_URL : 'https://www.youtube.com/watch?v='

   // FETCH GENRES //
  
  const fetchGenres= async () => {
    const res = await axios.get(`
    https://api.themoviedb.org/3/genre/movie/list?api_key=42e819daa18d18afdcfc202cac31412b&language=fr-FR`)
    
    setGenresName(res.data.genres)
    // console.log(res.data.genres)  
  }

  useEffect(() => {
    fetchGenres()
  }, [])
  

  const handleGenre = (value) => {
    setGenresId(`${value}`)
  }

  // DROPDOWN // 
  const handleChange = (event) => {
    setGenres(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };


  

  // BUTTON ACTION //

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const handleClick = () => {
     setNum(randomNumberInRange(1,30))
   
  }

  const IMG_PATH= "https://image.tmdb.org/t/p/original"

 
  return (

    <div className='main'>

      <div className='main_top'>
        <CustomMenu 
                open={open}
                genres={genres}
                genresName={genresName}
                handleOpen={handleOpen}
                handleClose={handleClose}
                handleChange={handleChange}
                handleGenre={handleGenre}
              />
              
              {num  ?
                  <p></p>
                : 
        <Custombutton
                action={
                  handleClick
                }
                text={'Proposer'}
                />
                }
      </div>
              

      {isLoading === true 
      ? 
      <Loader /> 
      : 
      
      movies.slice(1,2).map((movie) => 
        
      <MovieCard 
        id={movie.id} 
        title={movie.title}
        imageSrc={movie.poster_path}
        overview={movie.overview}
        vote_average={movie.vote_average}
        actionButton={handleClick}
        streamInfos={moviesStreamData.map((stream) => 
            <StreamCard
              streamName={stream.provider_name}
              streamLogo={stream.logo_path}
              />
        )}
        buyInfos={buyMoviesData.map((buy) => 
            <BuyCard
              buyName={buy.provider_name}
              buyLogo={buy.logo_path}
              />
        )}
       
        
        />

   )}


  
  

  

    </div>
  )
}

Main.propTypes = {}

export default Main


